import noFileFolderIllustration from "assets/images/no_file_folder.svg"
export const NoFilesFolderIllustration = () => (
    <div className='d-flex py-4 justify-content-center align-items-center' style={{ flexDirection: "column" }}>
        <img src={noFileFolderIllustration} />
        <span>No files or folders found...</span>
    </div>
)